

































import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

// TODO Input.vueの実装を流用したが、共通化できる箇所がある。
@Component
export default class Textarea extends Vue {
  @Inject()
  $validator: Validator

  @Prop()
  value

  @Prop()
  label: string

  @Prop({ required: true })
  name: string

  @Prop()
  placeholder: string

  @Prop()
  autocomplete: string

  @Prop()
  rows: string

  /*
   * Whether or not  the field has validation dependencies on other fields.
   * If this flag is set, some own logic on validation will be expected.
   */
  @Prop()
  hasDependencies: boolean

  hasError(): boolean {
    if (this.hasDependencies) {
      return this.$validator.errors.has(this.name) && this.isTouched(this.name)
    }

    return this.$validator.errors.has(this.name)
  }

  getErrorMessage(): string {
    return this.$validator.errors.first(this.name)
  }

  style() {
    return {
      'c-input': true,
      'c-input__textarea': true,
      'form-control': true,
      'form-control-sm': true,
      'is-invalid': this.hasError(),
      'border-danger': this.hasError(),
      'p-3': true,
    }
  }

  private isTouched(name: string): boolean {
    const field = this.$validator.fields.find({ name })

    if (!field) {
      return true
    }

    return field.flags.touched
  }

}
